import React from "react";
import { createRoot } from "react-dom/client";
import "@fas/react-scripts-ts";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import configureStore from "./store";
import App from "./components/App";
import "./index.css";

function prepare(): Promise<void> {
  if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DEV_SW) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    const { mockApi } = require("./mocks/browser");
    return mockApi.makeServer();
  }
  return Promise.resolve();
}

prepare().then(() => {
  const rootElement = document.getElementById("root");

  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <Provider store={configureStore()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    );
  }
});
